import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';

export const PasswordPreviewDiv = styled.div`
  /* These styles mimic a real input field */
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 2px 4px; /* Padding for desktop preview */
  height: ${({ height }) => height};

  ${Styles.FontStyles}
  ${Styles.BorderStyles}
`;